import { render, staticRenderFns } from "./UserReviewRecordsAdd.vue?vue&type=template&id=215b5f32&scoped=true&"
import script from "./UserReviewRecordsAdd.vue?vue&type=script&lang=js&"
export * from "./UserReviewRecordsAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserReviewRecordsAdd.vue?vue&type=style&index=0&id=215b5f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b5f32",
  null
  
)

export default component.exports